import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { toggleComplainPopup } from 'shared/store/hideOffer';

import { ComplaintButtonNew } from '../../components/ComplaintButtonNew';

export function ComplaintButtonNewContainer() {
  const dispatch = useDispatch();

  const onComplainPopupOpen = useEventCallback(() => {
    dispatch(toggleComplainPopup(true));
  });

  return <ComplaintButtonNew onClick={onComplainPopupOpen} />;
}
